export default __webpack_public_path__ + "static/media/bg9.1486bc31.png";